import React from 'react';

const AgentsBillingPage = () => {
  return (
    <div>
      <h1>Billing Page</h1>
    </div>
  );
};

export { AgentsBillingPage }; 